var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"workingArea"}},[_c('unlock-wallet'),_c('finished-rounds'),_c('how-to-play')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }